module.exports = __webpack_public_path__ + "static/media/santiago-abascal.93b8faa0.png";